import { addYears, getTzTodayDate } from '@ninja/utilities';

export const addYearsToDate = (date: Date | undefined, years: number) => {
	if (date) {
		return addYears(date, years);
	}

	return getTzTodayDate();
};
